module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qrepr1-1ea7d13f8860327ad065ab4ef5ceb348.jpg";